import { createAction, props } from '@ngrx/store';
import { LoginRequest } from '../../api/identity/models/login-request';
import { LoginApiResponse } from '../../api/identity/models/login-api-response';

export const login = createAction('[Auth] Login', props<{ request: LoginRequest }>());

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ response: LoginApiResponse }>()
);

export const loginFailure = createAction('[Auth] Login Failure', props<{ error: string }>());

export const logout = createAction('[Auth] Logout');
